import BaseState from 'Engine/base/states/BaseState';
import GlobalDispatcher from '../libs/game-engine/src/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';

export default class WinMultiplyState extends BaseState {

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add(eEventTypes.EET_WIN_MULTIPLY__COMPLETE, this.complete.bind(this));
  }

  complete() {
    if (this.active) {
      super.complete();
    }
  }
}
